module.exports = __webpack_public_path__ + "img/dq.ad65566.png";